// Node.js port of csharp Assembler.Timing.TimingPhase / lean4 Assembler.Base.Timing.TimingPhase.
//
// The closed phase vocabulary every engine reports (PLAN_TIMING_FIX.md §3). Load phases belong to
// TimingStage.Load, merge phases to TimingStage.Merge; Dynamic is valid in both. Harness phases belong
// to TimingStage.Harness and request phases to TimingStage.Request. Adding a phase is a contract change
// for every engine in every language.
export enum TimingPhase {
    Source,
    Parse,
    Prepare,
    Dynamic,
    Materialize,
    Resolve,
    Bind,
    Render,
    Assemble,
    Initialize,
    Execute,
    Compare,
    Save,
    Commit,
    Summary,
    Report,
    Generate,
    Package,
    Boot,
    Hydrate,
    Replay,
    Serialize
}
